module.exports = __webpack_public_path__ + "img/Service-ability-05.8bec62ed.png";